import { Group, Pagination, Select, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { OLCHAM_TANLOV } from '../hooks/usePagedQuery';

/**
 * Jadval ostidagi paginatsiya — sahifa raqamlari + SAHIFA HAJMI tanlovi.
 *
 * Ilgari har sahifada faqat `<Pagination>` turardi va hajm kodda qat'iy
 * yozilgandi (20). Ikki muammo bor edi:
 *  • ro'yxatlar har xil: to'lovlar tarixida 10 ta yetarli, o'quvchilar
 *    ro'yxatini esa 100 talab ko'rgan qulayroq — bitta qiymat ikkalasiga ham
 *    noqulay edi;
 *  • `pages > 1` sharti bo'lgani uchun bitta sahifalik ro'yxatda umumiy son
 *    ham ko'rinmasdi: "hammasi shumi yoki filtr noto'g'rimi?" degan savol
 *    javobsiz qolardi.
 *
 * Endi hajm tanlovi va umumiy son HAR DOIM ko'rinadi, sahifa raqamlari esa
 * faqat kerak bo'lganda.
 */
export function TablePagination({
  page,
  pages,
  total,
  limit,
  onPage,
  onLimit,
}: {
  page: number;
  pages: number;
  total: number;
  limit: number;
  onPage: (n: number) => void;
  onLimit: (n: number) => void;
}) {
  const { t } = useTranslation();
  if (!total) return null;

  /* Nechtadan nechtagacha ko'rsatilyapti — foydalanuvchi qayerda turganini
     sahifa raqamidan ko'ra aniqroq tushunadi. */
  const boshi = (page - 1) * limit + 1;
  const oxiri = Math.min(page * limit, total);

  return (
    <Group justify="space-between" mt="md" wrap="wrap" gap="sm">
      <Text size="sm" c="dimmed">
        {t('pager.range', { from: boshi, to: oxiri, total })}
      </Text>

      <Group gap="sm" wrap="nowrap">
        {pages > 1 && (
          <Pagination value={page} onChange={onPage} total={pages} size="sm" withEdges />
        )}
        <Select
          size="xs"
          w={96}
          aria-label={t('pager.perPage')}
          data={OLCHAM_TANLOV.map((n) => ({ value: String(n), label: `${n} / ${t('pager.page')}` }))}
          value={String(limit)}
          onChange={(v) => v && onLimit(Number(v))}
          allowDeselect={false}
          comboboxProps={{ withinPortal: true }}
        />
      </Group>
    </Group>
  );
}
